import { HTMLAttributes } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { map } from 'lodash'

import Image from '@/components/base/lazy-image'

import { WPImage } from '@/types'

export type ImageGalleryProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    collection: WPImage[]
  }>

const ImageGallery = ({ collection = [], ...props }: ImageGalleryProps) => {
  const [emblaRef] = useEmblaCarousel({ dragFree: true })

  return (
    <div ref={emblaRef} className="h-[40rem] overflow-hidden px-margin md:h-[70rem]" {...props}>
      <div className="-ml-[1rem] flex h-full w-auto touch-pan-y">
        {map(collection, (image, index) => (
          <div
            key={`image-${index}`}
            className="relative h-full shrink-0 grow-0 pl-[1rem]"
            style={{ aspectRatio: `${image.width}/${image.height}` }}
          >
            <span className="relative flex size-full">
              <Image src={image.url} alt={image.alt} fill />
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ImageGallery
